import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "TeaserGrid",
    component: () => (__SERVER__ ? require("./teaser-grid-view") : import("./teaser-grid-view"))
});

export default definition;
